export default __webpack_public_path__ + "static/media/C.17007b5e.svg";